/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import RoomsView from '../../view/pages/room/RoomsView'
import RoomsStore from '../../store/room/RoomsStore'
import RoomAction from '../../action/room'

class RoomsContainer extends Component {
  static getStores() {
    return [RoomsStore]
  }

  static calculateState(prevState, props) {
    return {
      rooms: RoomsStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    RoomAction.fetchAll()
  }

  render() {
    return RoomsView(this.state)
  }
}

export default withRouter(Container.create(RoomsContainer, { withProps: true }))
